/* Reveal-on-scroll: fade + slight rise as the element enters the
   viewport. Respects prefers-reduced-motion (renders visible, no
   transform). One observer per element, disconnected after reveal. */
import { useEffect, useRef, useState } from 'react'

const prefersReducedMotion =
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

export function Reveal({ children, className }) {
  const ref = useRef(null)
  const [shown, setShown] = useState(prefersReducedMotion)

  useEffect(() => {
    if (prefersReducedMotion) return
    const el = ref.current
    if (!el) return
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setShown(true)
          io.disconnect()
        }
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.05 },
    )
    io.observe(el)
    return () => io.disconnect()
  }, [])

  return (
    <div ref={ref} className={'reveal ' + (shown ? 'in ' : '') + (className || '')}>
      {children}
    </div>
  )
}
